import React, { useState } from 'react';
import { NewsletterSignupContent } from '../components/NewsletterPopup';
import { subscribeToNewsletter } from '../api/newsletter';
import logo from '../assets/logomiestampita.png';
import useSEO from '../hooks/useSEO';
import './Newsletter.css';

export default function Newsletter() {
  useSEO({
    title: 'Newsletter | MiEstampita',
    description: 'Suscribite para recibir información sobre nuevas colecciones y beneficios especiales de MiEstampita.',
    path: '/newsletter',
  });

  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!firstName.trim()) {
      setError('Ingresá tu nombre.');
      return;
    }

    if (!email.trim()) {
      setError('Ingresá un email válido.');
      return;
    }

    try {
      setStatus('loading');
      setError('');
      await subscribeToNewsletter({
        name: firstName.trim(),
        email: email.trim(),
      });

      setStatus('success');
    } catch (submitError) {
      setStatus('error');
      setError(submitError.message || 'No se pudo registrar el email. Intentá nuevamente.');
    }
  };

  return (
    <main className="newsletter-page">
      <div className="newsletter-page__box">
        <img src={logo} alt="MiEstampita Logo" className="newsletter-page__logo" />
        <NewsletterSignupContent
          titleId="newsletter-page-title"
          title="Sé la primera en enterarte"
          description="Recibí información sobre nuevas colecciones y beneficios especiales."
          showBenefits={false}
          buttonLabel="QUIERO ENTERARME"
          bottomText=""
          firstName={firstName}
          setFirstName={setFirstName}
          email={email}
          setEmail={setEmail}
          status={status}
          error={error}
          handleSubmit={handleSubmit}
        />
      </div>
    </main>
  );
}
